import { Component, OnInit, Input } from '@angular/core';
import { EncuestaCovidPreguntaDetalleEntity } from '../../../../services/servicio-encuesta-covid.service';

@Component({
  selector: 'app-lista-desplegable',
  templateUrl: './lista-desplegable.component.html',
  styleUrls: ['./lista-desplegable.component.css']
})
export class ListaDesplegableComponent implements OnInit {

  value: number;

  @Input() public pregunta: EncuestaCovidPreguntaDetalleEntity;

  constructor() { }

  ngOnInit() {
    if(this.pregunta && this.pregunta.resultado){
      this.value = Number(this.pregunta.resultado.resultado);
    }
  }

  isSelected(p: any) {
    return p.id === this.value;
  }

}
